'use client';

import { usePathname } from 'next/navigation';
import type { PropsWithChildren } from 'react';
import type { MenuClientHideConditions } from '../helpers';

type FooterMenuLinkClientWrapperProps = {
  url: string;
  hideConditions?: MenuClientHideConditions[];
  hideConditionResults: Record<string, boolean>;
};

export const FooterMenuLinkClientWrapper = ({
  url,
  children,
  hideConditions,
  hideConditionResults,
}: PropsWithChildren<FooterMenuLinkClientWrapperProps>) => {
  const pathname = usePathname();

  const checkHideConditions = () =>
    hideConditions?.some((condition) => hideConditionResults[condition]);
  const isHidden = checkHideConditions();
  const isActive = url === pathname;

  if (isHidden) return null;

  return <li className={isActive ? 'active' : ''}>{children}</li>;
};
